import type { ChartRunState } from "../../viewer/storage/runState.ts";
import ChartContainer from "./ChartContainer.tsx";
import ChartViewer from "./ChartViewer.tsx";

interface Props {
  runState: ChartRunState;
}
export default function ChartViewerContainer({ runState }: Props) {
  return (
    <ChartContainer>
      <ChartViewer runState={runState} />
    </ChartContainer>
  );
}
